<script setup lang="ts">
  import { IconScanAlarmError, Button } from "@ui-kit";
  import { default as Wrapper } from "./Wrapper.vue";

  const emit = defineEmits<{ (e: "click:cancel"): void }>();
</script>

<template>
  <Wrapper :title="$t('Не удалось записать данные')" :subtitle="$t('Попробуйте снова приложить hard tag к сканеру')">
    <template #icon>
      <IconScanAlarmError />
    </template>
    <template #buttons>
      <Button variant="secondary" @click="emit('click:cancel')">Отмена</Button>
    </template>
  </Wrapper>
</template>
